import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
export const Input = forwardRef(function Input({ className, ...props }, ref) {
    return (_jsx("input", { ref: ref, className: `w-full min-h-11 rounded-sm border border-border-default bg-inset text-fg-primary py-2.5 px-3 text-[0.95rem] ${className ?? ''}`, ...props }));
});
//# sourceMappingURL=Input.js.map